import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPowderCoatingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "powder_coating-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M92.15,61.56a.44.44,0,0,0,0-.16h0l-.06-.15,0,0L92,61.1l0,0A.69.69,0,0,0,91.8,61L50.23,37a.71.71,0,0,0-.72,0L8.2,60.81a.69.69,0,0,0-.13.11l0,0-.07.1,0,0-.06.15h0a.47.47,0,0,0,0,.17h0v4.32a.73.73,0,0,0,.36.63l41.57,24a.76.76,0,0,0,.72,0L91.8,66.53a.73.73,0,0,0,.36-.63V61.56Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,61.51a.73.73,0,0,0,0-.22l0-.07a1,1,0,0,0-.09-.21l0-.06a1.1,1.1,0,0,0-.14-.18l0-.05a1.13,1.13,0,0,0-.23-.17l-41.57-24a1.17,1.17,0,0,0-1.2,0L8,60.4a1.13,1.13,0,0,0-.23.17l-.05.06a1.09,1.09,0,0,0-.13.17l0,.06a1.89,1.89,0,0,0-.09.21v0a.69.69,0,0,0,0,.25v4.38a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.94a1.2,1.2,0,0,0,.6-1V61.51ZM92,61.1Zm-43,25v1.54L9.76,65.06V63.51ZM89,61.58,50.13,84.05,11,61.43,49.87,39Zm1.2,2.08v1.55L51.33,87.67V86.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,35.42a1.2,1.2,0,0,0-1.2,1.2V39.9a1.2,1.2,0,1,0,2.4,0V36.62A1.2,1.2,0,0,0,50,35.42Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,42a1.2,1.2,0,0,0-1.2,1.2v3.28a1.2,1.2,0,1,0,2.4,0V43.17A1.2,1.2,0,0,0,50,42Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,28.87a1.2,1.2,0,0,0-1.2,1.2v3.28a1.2,1.2,0,1,0,2.4,0V30.07A1.2,1.2,0,0,0,50,28.87Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,48.52a1.2,1.2,0,0,0-1.2,1.2V53a1.2,1.2,0,0,0,2.4,0V49.72A1.2,1.2,0,0,0,50,48.52Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,55.07a1.2,1.2,0,0,0-1.2,1.2v3.28a1.2,1.2,0,0,0,2.4,0V56.27A1.2,1.2,0,0,0,50,55.07Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,61.62a1.2,1.2,0,0,0-1.2,1.2v.67a1.2,1.2,0,1,0,2.4,0v-.67A1.2,1.2,0,0,0,50,61.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M56.24,40.28a1.2,1.2,0,0,0,.85-1.47l-.85-3.17a1.18,1.18,0,0,0-.56-.73,1.15,1.15,0,0,0-.91-.11,1.2,1.2,0,0,0-.72.55,1.19,1.19,0,0,0-.12.92l.84,3.16a1.21,1.21,0,0,0,1.16.89A1.55,1.55,0,0,0,56.24,40.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M57.94,46.6a1.18,1.18,0,0,0,.73-.56,1.2,1.2,0,0,0,.12-.91L57.94,42a1.18,1.18,0,0,0-.56-.73,1.21,1.21,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.21,1.21,0,0,0-.12.91l.85,3.16a1.2,1.2,0,0,0,1.16.89A1.1,1.1,0,0,0,57.94,46.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.55,34a1.18,1.18,0,0,0,.73-.56,1.21,1.21,0,0,0,.12-.91l-.85-3.16a1.18,1.18,0,0,0-.56-.73,1.21,1.21,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56,1.21,1.21,0,0,0-.12.91l.85,3.16a1.2,1.2,0,0,0,1.16.89A1.1,1.1,0,0,0,54.55,34Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M52.85,27.62a1.18,1.18,0,0,0,.73-.56,1.2,1.2,0,0,0,.12-.91l-.18-.68.35.61a1.24,1.24,0,0,0,1.64.44A1.2,1.2,0,0,0,56,24.88l-.35-.61.5.5a1.2,1.2,0,0,0,1.7-1.7l-7-7-.06-.05-.34-.2L50,15.78l-.41.06.07.23-.12-.22-.13.07-.07,0-.13.09.14.19h0l-.18-.16-7,7a1.2,1.2,0,1,0,1.7,1.7l.5-.5-.35.61a1.2,1.2,0,0,0,.44,1.64,1.24,1.24,0,0,0,1.64-.44l.35-.61-.18.68a1.2,1.2,0,0,0,.12.91,1.18,1.18,0,0,0,.73.56,1.22,1.22,0,0,0,1.47-.84l.18-.69v.71a1.2,1.2,0,1,0,2.4,0v-.71l.18.69a1.2,1.2,0,0,0,1.16.88A1.06,1.06,0,0,0,52.85,27.62ZM50.38,16.1Zm-.06,0Zm-.1,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M63,61a1.2,1.2,0,0,0-2.32.62l.17.65a1.21,1.21,0,0,0,1.16.89,1.65,1.65,0,0,0,.31,0,1.21,1.21,0,0,0,.85-1.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M59.63,52.93a1.18,1.18,0,0,0,.73-.56,1.16,1.16,0,0,0,.12-.91l-.85-3.16A1.19,1.19,0,0,0,57.44,48a1.16,1.16,0,0,0-.12.91l.84,3.16a1.22,1.22,0,0,0,1.16.89A1.06,1.06,0,0,0,59.63,52.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M61.33,59.26a1.25,1.25,0,0,0,.73-.56,1.21,1.21,0,0,0,.12-.91l-.85-3.17a1.18,1.18,0,0,0-.56-.73,1.16,1.16,0,0,0-.91-.11A1.18,1.18,0,0,0,59,55.24l.85,3.17A1.21,1.21,0,0,0,61,59.3,1.65,1.65,0,0,0,61.33,59.26Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M74,56.08a1.2,1.2,0,1,0-2.08,1.2l.34.58a1.2,1.2,0,0,0,1,.6,1.25,1.25,0,0,0,.6-.16,1.21,1.21,0,0,0,.44-1.64Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M60.42,37.43h0a1.22,1.22,0,0,0,1,.6,1.25,1.25,0,0,0,.6-.16,1.21,1.21,0,0,0,.44-1.64l-1.64-2.84a1.2,1.2,0,1,0-2.07,1.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M72.33,53.24l-1.64-2.83a1.2,1.2,0,1,0-2.08,1.2l1.64,2.83a1.2,1.2,0,0,0,1,.6,1.17,1.17,0,0,0,.6-.16A1.2,1.2,0,0,0,72.33,53.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M69.05,47.57l-1.64-2.83a1.2,1.2,0,1,0-2.07,1.2L67,48.77a1.22,1.22,0,0,0,1,.6,1.15,1.15,0,0,0,.6-.16A1.2,1.2,0,0,0,69.05,47.57Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M59.23,30.56l-1.64-2.84h0a1.18,1.18,0,0,0-.73-.56,1.2,1.2,0,0,0-1.35,1.76l1.64,2.84a1.2,1.2,0,0,0,2.08-1.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M65.78,41.9l-1.64-2.84a1.25,1.25,0,0,0-.73-.56,1.2,1.2,0,0,0-1.35,1.76L63.7,43.1a1.2,1.2,0,0,0,1,.6,1.28,1.28,0,0,0,.6-.16A1.21,1.21,0,0,0,65.78,41.9Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M67.68,36.35,70,38.66a1.18,1.18,0,0,0,1.7,0,1.15,1.15,0,0,0,.35-.84,1.17,1.17,0,0,0-.35-.85l-2.32-2.32a1.2,1.2,0,0,0-1.69,1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M63.05,31.72,65.36,34a1.2,1.2,0,1,0,1.7-1.69L64.74,30a1.2,1.2,0,1,0-1.69,1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M58.41,27.09l2.32,2.31a1.21,1.21,0,0,0,1.7,0,1.21,1.21,0,0,0,.35-.85,1.23,1.23,0,0,0-.35-.85l-2.32-2.31a1.2,1.2,0,0,0-1.7,0,1.21,1.21,0,0,0,0,1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M76.32,41.6,74,39.28a1.22,1.22,0,0,0-1.7,0,1.21,1.21,0,0,0,0,1.7l2.31,2.32a1.21,1.21,0,0,0,1.7,0,1.21,1.21,0,0,0,0-1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M81,46.23l-2.31-2.32a1.22,1.22,0,0,0-1.7,0,1.21,1.21,0,0,0,0,1.7l2.32,2.32a1.19,1.19,0,0,0,.84.35,1.21,1.21,0,0,0,.85-.35,1.21,1.21,0,0,0,0-1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M83.74,49l-.47-.47a1.2,1.2,0,0,0-1.7,0,1.19,1.19,0,0,0,0,1.69l.47.48a1.21,1.21,0,0,0,1.7,0A1.2,1.2,0,0,0,83.74,49Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M46.92,28.47a1.21,1.21,0,0,0-.91.12,1.18,1.18,0,0,0-.56.73l-.85,3.16a1.21,1.21,0,0,0,.12.91,1.18,1.18,0,0,0,.73.56,1.1,1.1,0,0,0,.31,0,1.2,1.2,0,0,0,1.16-.89l.85-3.16a1.21,1.21,0,0,0-.12-.91A1.18,1.18,0,0,0,46.92,28.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M45.22,34.8a1.14,1.14,0,0,0-.9.11,1.18,1.18,0,0,0-.56.73l-.85,3.17a1.2,1.2,0,0,0,.85,1.47,1.55,1.55,0,0,0,.31,0,1.21,1.21,0,0,0,1.16-.89l.84-3.16a1.19,1.19,0,0,0-.85-1.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M38.44,60.1a1.21,1.21,0,0,0-.91.12A1.25,1.25,0,0,0,37,61l-.17.65a1.21,1.21,0,0,0,.85,1.47,1.65,1.65,0,0,0,.31,0,1.21,1.21,0,0,0,1.16-.89l.17-.65a1.16,1.16,0,0,0-.12-.91A1.18,1.18,0,0,0,38.44,60.1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M43.53,41.12a1.2,1.2,0,0,0-.91.12,1.18,1.18,0,0,0-.56.73l-.85,3.16a1.2,1.2,0,0,0,.12.91,1.18,1.18,0,0,0,.73.56,1.1,1.1,0,0,0,.31,0,1.2,1.2,0,0,0,1.16-.89l.85-3.16a1.21,1.21,0,0,0-.12-.91A1.18,1.18,0,0,0,43.53,41.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M41.83,47.45h0a1.19,1.19,0,0,0-1.46.85l-.85,3.16a1.16,1.16,0,0,0,.12.91,1.18,1.18,0,0,0,.73.56,1.06,1.06,0,0,0,.31,0,1.2,1.2,0,0,0,1.16-.89l.84-3.16a1.16,1.16,0,0,0-.12-.91A1.18,1.18,0,0,0,41.83,47.45Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40.14,53.78a1.16,1.16,0,0,0-.91.11,1.18,1.18,0,0,0-.56.73l-.85,3.17a1.21,1.21,0,0,0,.12.91,1.25,1.25,0,0,0,.73.56,1.65,1.65,0,0,0,.31,0,1.21,1.21,0,0,0,1.16-.89L41,55.24a1.18,1.18,0,0,0-.85-1.46Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M42.85,31.76l1.64-2.84a1.2,1.2,0,0,0-1.35-1.76,1.18,1.18,0,0,0-.73.56l-1.64,2.84a1.2,1.2,0,0,0,2.08,1.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40.78,33a1.23,1.23,0,0,0-.92-.12,1.19,1.19,0,0,0-.72.56L37.5,36.23a1.21,1.21,0,0,0,.44,1.64,1.25,1.25,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6l1.63-2.84A1.19,1.19,0,0,0,40.78,33Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M27.68,55.64a1.23,1.23,0,0,0-.92-.12,1.18,1.18,0,0,0-.72.56l-.34.58a1.21,1.21,0,0,0,.44,1.64,1.25,1.25,0,0,0,.6.16,1.2,1.2,0,0,0,1-.6l.34-.58A1.21,1.21,0,0,0,27.68,55.64Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M34.23,44.3a1.16,1.16,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56L31,47.57a1.2,1.2,0,0,0,.44,1.64,1.15,1.15,0,0,0,.6.16,1.22,1.22,0,0,0,1-.6l1.64-2.83A1.2,1.2,0,0,0,34.23,44.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31,50a1.21,1.21,0,0,0-.91-.12,1.18,1.18,0,0,0-.73.56l-1.64,2.83a1.2,1.2,0,0,0,.44,1.64,1.17,1.17,0,0,0,.6.16,1.2,1.2,0,0,0,1-.6l1.64-2.83A1.21,1.21,0,0,0,31,50Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M37.5,38.62a1.21,1.21,0,0,0-.91-.12,1.25,1.25,0,0,0-.73.56L34.22,41.9a1.21,1.21,0,0,0,.44,1.64,1.28,1.28,0,0,0,.6.16,1.2,1.2,0,0,0,1-.6l1.64-2.84A1.21,1.21,0,0,0,37.5,38.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M28,40.13a1.19,1.19,0,0,0-.35-.85,1.21,1.21,0,0,0-1.69,0L23.68,41.6a1.21,1.21,0,0,0,0,1.7,1.21,1.21,0,0,0,1.7,0L27.69,41A1.19,1.19,0,0,0,28,40.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M16.73,48.55l-.47.47a1.17,1.17,0,0,0-.35.85,1.19,1.19,0,0,0,.35.85,1.21,1.21,0,0,0,1.7,0l.47-.48a1.2,1.2,0,0,0,0-1.69A1.2,1.2,0,0,0,16.73,48.55Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M33.79,34.38a1.19,1.19,0,0,0,.85-.35L37,31.72A1.2,1.2,0,1,0,35.26,30l-2.32,2.32a1.2,1.2,0,0,0,.85,2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M29.16,39a1.2,1.2,0,0,0,.85-.36l2.31-2.31a1.2,1.2,0,1,0-1.69-1.7L28.31,37a1.17,1.17,0,0,0-.35.85,1.15,1.15,0,0,0,.35.84A1.2,1.2,0,0,0,29.16,39Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M38.42,29.75a1.19,1.19,0,0,0,.85-.35l2.32-2.31a1.21,1.21,0,0,0,0-1.7,1.2,1.2,0,0,0-1.7,0L37.57,27.7a1.23,1.23,0,0,0-.35.85,1.21,1.21,0,0,0,.35.85A1.19,1.19,0,0,0,38.42,29.75Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M21.36,43.91l-2.31,2.32a1.21,1.21,0,0,0,0,1.7,1.21,1.21,0,0,0,.85.35,1.19,1.19,0,0,0,.84-.35l2.32-2.32a1.17,1.17,0,0,0,.35-.85,1.19,1.19,0,0,0-.35-.85A1.22,1.22,0,0,0,21.36,43.91Z"
			})
		]
	})]
});
export default SvgPowderCoatingSm;
